class LocationStore {
  lastLocation = null;

  getLastLocation() {
    return this.lastLocation;
  }

  setLastLocation(location) {
    this.lastLocation = location;
    return this;
  }
}

export default new LocationStore();



// WEBPACK FOOTER //
// ./src/stores/Location.store.js